<template>
    <div class="vimeo-player-wrapper">
        <template v-if="preview && !isFirstPlaying">
            <button @click="play" v-if="!loaderDisplay" type="button" class="vimeo-player__button-play">
                <img src="@images/portal/cta-play-icon-black.svg" alt=">" />
            </button>
            <img class="vimeo-player__preview" :src="preview" :alt="'preview'" />
        </template>
        <vue-vimeo-player
            ref="player"
            class="vimeo-player"
            :options="vimeoOptions"
            :player-width="vimeoWidth"
            :player-height="vimeoHeight"
            :video-id="vimeoKey"
            @timeupdate="onPlayerTimeupdate($event)"
            @ready="vimeoPlayerIsReady"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @ended="onPlayerEnded($event)"
        />
    </div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player"
import { EventBus, EventsList } from "~events"
import { timeToSecond } from "@helpers"

export default {
    name: "VimeoPlayer",
    components: {
        vueVimeoPlayer
    },
    props: {
        videoUrl: {
            type: String
        },
        parent: {
            type: String
        },
        preview: {
            type: String
        },
        infoUnitId: {
            type: [Number, String],
            required: false
        }
    },
    data() {
        return {
            vimeoOptions: {
                id: null,
                url: null,
                title: false,
                byline: false,
                portrait: false,
                color: "ff7439",
                responsive: true
            },
            loaderDisplay: false,
            isFirstPlaying: false,
            vimeoPlayer: null,
            vimeoKey: null,
            vimeoWidth: null,
            videoStart: null,
            needScroll: false,
            vimeoHeight: null
        }
    },
    methods: {
        play() {
            this.$refs.player.play()
        },
        onPlayerTimeupdate(val) {
            this.$emit("timeupdate", val)
        },
        vimeoPlayerIsReady(player) {
            this.vimeoPlayer = player
            if (!this.videoStart) this.videoStart = timeToSecond(this.videoUrl)
            this.$emit("ready", player)
        },
        onPlayerPlay() {
            if (!this.isFirstPlaying) {
                this.isFirstPlaying = true
            }
            this.$emit("play")
        },
        onPlayerPause() {
            this.$emit("pause")
        },
        onPlayerEnded() {
            this.$emit("ended")
        },
        isInteger(value) {
            return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value
        },
        extractVimeoKey(url) {
            // const regExp = /vimeo.com\/external\/(\d+)/
            const regExp = /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:.*\/)?(?:video\/)?(\d+)/
            let match = url.match(regExp)
            //fix bug
            const newURl = new URL(url)
            const pathNames = newURl.pathname.replace("/", "").split("/")
            const indexCurrPath = pathNames.findIndex(i => i === match[1])
            if (indexCurrPath !== -1 && pathNames[indexCurrPath + 1]) {
                return match[1] + "/" + pathNames[indexCurrPath + 1]
            }
            return match[1]
        }
    },
    created() {
        this.vimeoOptions.url = this.videoUrl

        // this.vimeoKey = this.extractVimeoKey(this.videoUrl)
        //
        // if (this.isInteger(this.vimeoKey)) {
        //     this.vimeoOptions.id = this.vimeoKey
        // } else {
        //     this.vimeoOptions.url = this.videoUrl
        // }

        EventBus.$on(EventsList.VIDEO_SET_SEEK, ({ unitId, seekTo }) => {
            if (this.infoUnitId === unitId) {
                if (this.vimeoPlayer) {
                    this.vimeoPlayer.setCurrentTime(seekTo)
                } else {
                    console.info("[seek to]: Vimeo player no init")
                }
            }
        })
    }
}
</script>

<style lang="sass">
.vimeo-player
    width: 100%

    & > div
        padding-top: 56.25% !important

    iframe
        max-height: none

    .loader-block
        position: absolute
        top: 0
        right: 0
        left: 0
        bottom: 0
        z-index: 1
        height: 100%
        background-color: rgba(0,0,0, 0.50)
    &__preview
        width: 100%
        height: 100%
        position: absolute
        top: 0
        right: 0
        left: 0
        display: block
        z-index: 2
        object-fit: cover
    &__button-play
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        width: 70px
        height: 70px
        z-index: 3
        opacity: .8
        @media (max-width: 990px)
            width: 55px
            height: 55px
        @media (max-width: 640px)
            width: 45px
            height: 45px
        img
            width: 100%
            height: 100%
</style>
